var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRankingActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_802_2115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.578735 0.349609V20.2079H3.06103V0.349609H0.578735ZM5.54332 0.349609V10.2788H10.5079V12.7611H20.4371L15.4725 7.87095L20.4371 2.8319H12.9902V0.349609H5.54332V0.349609Z",
    fill: "#1F2024"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_802_2115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.8583,
    height: 19.8583,
    fill: "white",
    transform: "translate(0.578735 0.349609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankingActive);
export default __webpack_public_path__ + "static/media/rankingActive.85466041d4feb508c514a99fb6c29b35.svg";
export { ForwardRef as ReactComponent };